
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 340 255","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M340 38h-25V25H25v13H0V0h340v38zm0 179v38H0v-38h25v13h290v-13h25zm-29 9h-25v-9h25v9zm0-188h-25v-9h25v9zM54 38H29v-9h25v9zm0 188H29v-9h25v9z","fill":"#9D9D9D"}}),_c('path',{attrs:{"d":"M282 202v11H58v-11h224zM58 53V42h224v11H58zm253 73h-11V80h11v46zm-14-84v46h-11V42h11zm0 125v46h-11v-46h11zm14 7h-11v-46h11v46zM43 42h11v46H43V42zM286 0v25h-4V0h4zm29 0v25h-4V0h4zM29 0v25h-4V0h4zm29 0v25h-4V0h4zm228 230v25h-4v-25h4zm29 0v25h-4v-25h4zm-286 0v25h-4v-25h4zm29 0v25h-4v-25h4zm-15-63v46h11v-46H43zm-14-41h11V80H29v46zm0 48h11v-46H29v46z","fill":"#7000BD"}})])])
          )
        }
      }
    